var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultImageBranco(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 55,
    viewBox: "0 0 67 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 0.686035H6.5C3.5 0.686035 0.5 3.68604 0.5 6.68604V48.686C0.5 51.986 3.2 54.686 6.5 54.686H60.5C63.5 54.686 66.5 51.686 66.5 48.686V6.68604C66.5 3.68604 63.5 0.686035 60.5 0.686035ZM60.5 48.446C60.44 48.536 60.32 48.626 60.26 48.686H6.5V6.92603L6.74 6.68604H60.23C60.32 6.74604 60.41 6.86603 60.47 6.92603V48.446H60.5ZM30.5 38.216L23 29.186L12.5 42.686H54.5L41 24.686L30.5 38.216Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImageBranco);
export default __webpack_public_path__ + "static/media/defaultImage_branco.2cf02419f1f2b77dbe51c84412d6d72d.svg";
export { ForwardRef as ReactComponent };